import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { DIFFERENCE_TIME_UNITS, getDifferenceToNow } from 'utils/dateTime';

import { TLoyaltyCooldown } from './types';

export const useLoyaltyIncentiveCooldown = ({
  incentiveType,
}: {
  incentiveType: LoyaltyPromotionType;
}): TLoyaltyCooldown => {
  const { loyaltyUser } = useLoyaltyUser();
  const enableRewardCooldown = useFlag(LaunchDarklyFlag.ENABLE_REWARD_COOLDOWN);

  if (!loyaltyUser) {
    return { isActive: false };
  }

  if (incentiveType === LoyaltyPromotionType.REWARD && !enableRewardCooldown) {
    return { isActive: false };
  }

  const { availableAfter } =
    loyaltyUser[
      incentiveType === LoyaltyPromotionType.OFFER
        ? 'offerRedemptionAvailability'
        : 'rewardRedemptionAvailability'
    ] || {};

  if (getDifferenceToNow(DIFFERENCE_TIME_UNITS.SECONDS, availableAfter) > 0) {
    return { isActive: true, endsAt: new Date(availableAfter) };
  }

  return { isActive: false };
};
